// extracted by mini-css-extract-plugin
module.exports = {"root":"SectionHeader_root__3Onio"};